<template>
  <BaseAction class="new-talent-pool-with-workers">
    <NewTalentPoolDialog
      @close="closeDialog"
      @onSuccess="onSuccess"
      :additionalAction="addUsersToNewTalentPool"
      v-if="isOpen"
    />
    <SecondaryButton @click.native="openDialog" textColor="#0965dc">
      <div class="d-flex align-center justify-center">
        <v-icon small>mdi-arrow-right</v-icon>
        <inline-svg
          :src="require('@/assets/svg/pool_icon_white.svg')"
          height="15"
        />
        <v-icon small>mdi-plus</v-icon>
      </div>
      New Pool...
    </SecondaryButton>
  </BaseAction>
</template>

<script>
import SecondaryButton from "@/components/common/Button/SecondaryButton";
import NewTalentPoolDialog from "@/views/workers/TalentPools/dialogs/NewTalentPoolDialog";
import { TALENT_POOLS_NAMESPACE } from "@/store/modules/talentPools";
import { ADD_USERS_TO_TALENT_POOL } from "@/store/modules/talentPools/actions";
import { createNamespacedHelpers } from "vuex";
import BaseAction from "@/components/common/BaseAction";
import InlineSvg from "vue-inline-svg";

const { mapActions } = createNamespacedHelpers(TALENT_POOLS_NAMESPACE);

export default {
  name: "NewTalentPoolWithWorkersAction",
  components: {
    SecondaryButton,
    NewTalentPoolDialog,
    BaseAction,
    InlineSvg
  },
  props: {
    users: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      isOpen: false,
      newTalentPoolId: null
    };
  },
  methods: {
    ...mapActions({
      addUsersToTalentPool: ADD_USERS_TO_TALENT_POOL
    }),
    async addUsersToNewTalentPool(id) {
      const users = this.users;
      this.newTalentPoolId = id;
      return this.addUsersToTalentPool({ id, users });
    },
    onSuccess() {
      this.closeDialog();
      if (this.newTalentPoolId) {
        this.$router.push({
          name: "talentPoolPeople",
          params: { id: this.newTalentPoolId }
        });
      }
    },
    openDialog() {
      this.isOpen = true;
    },
    closeDialog() {
      this.isOpen = false;
    }
  }
};
</script>
<style lang="scss">
.new-talent-pool-with-workers {
  svg path {
    stroke: $primary-darker;
  }
}
</style>
